import { installationConfig } from "@/shared/constants/installation-config";

export const setBackground = () => {
  const loginPage = document?.getElementById("login-page");
  if (loginPage) {
    loginPage.style.background = installationConfig.background;
  }
};

export const setBackgroundMobile = () => {
  const loginPage = document?.getElementById("login-page");
  if (loginPage) {
    loginPage.style.background = installationConfig.backgroundMobile;
    loginPage.style.backgroundSize = installationConfig.backgroundMobileSize;
  }
};
